import React, { useState } from 'react';
import { Box, Typography, Card, Stack } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { CommonEditButton, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';
import { renderTitle, ActionButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { painLevelTxt, painScaleImgList } from '../../../../Utility/Constants';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import ShowComponents from '../Common/ShowComponent';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';

const SarasPainScale = ({ Title, ...props }) => {
    const [state, setState] = useState({
        painScaleList: [],
        isDeleteClicked: false,
        deleteID: null,
        painDate: new Date(),
        painValue: "",
        selectedID: null,
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = () => {
        getPainScaleData();
    }

    const getPainScaleData = () => {
        try {
            let params = ''
            if(props?.fromIp){
                params = Serviceurls.SAR_IP_DOC_NOTES_PAINCHART_GET + `?clinic_id=${props?.clinicId}&ip_admission_id=${props?.admission_id}&doctor_id=${props?.doctor_id}`
            }else{
                params = Serviceurls.SARAS_DOC_PAINCHART_GET + `?appointment_id=${props?.appointmentId}`
            }
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ painScaleList: response.data.data || [] })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    // table actions start
    const popupClose = () => {
        updateState({
            isDeleteClicked: false,
            deleteID: null,
        })
    }

    const deletePainScale = () => {
        try {
            let params = ''
            if(props?.fromIp){
                params = Serviceurls.SAR_IP_DOC_NOTES_PAINCHART_GET + `?clinic_id=${props?.clinicId}&ip_admission_id=${props?.admission_id}&doctor_id=${props?.doctor_id}&id=${state.deleteID}`
            }else{
                params = Serviceurls.SARAS_DOC_PAINCHART_GET + "?id=" + state.deleteID
            }
            RestAPIService.delete(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        popupClose()
                        props.successMessage(response.data.message)
                        getPainScaleData()
                        if (props?.fromIp) {
                            props?.callHistory(true)
                        }
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const onEditHandler = (data) => {
        updateState({
            painDate: data.pain_chart_date,
            painValue: data.pain_level,
            selectedID: data.id
        })
    }

    const onDeleteHandler = (data) => {
        updateState({
            isDeleteClicked: true,
            deleteID: data.id,
        })
    }
    // table actions end

    const ClearData = () => {
        updateState({
            painValue: "",
            selectedID: null,
            painDate: new Date(),
        })
    }

    const postPainScale = () => {
        const { t, appointmentId } = props
        try {
            const startDate = new Date(state.painDate)
            const date = (state.painDate) ? DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd") : state.painDate
            const Time = (state.painDate) ? DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS) : state.painDate
            const data = {
                "id": state.selectedID || null,
                "appointment_id": appointmentId,
                "pain_chart_date": (date + " " + Time),
                "pain_level": state.painValue
            }
            if (props?.fromIp) {
                data['clinic_id'] = props?.clinicId || null
                data['ip_admission_id'] = props?.admission_id || null
                data['doctor_id'] = props?.doctor_id || null
            }
            if (state.painValue === "") {
                props.errorMessage(t("Enter Pain level"))
            } else {
                let path = props.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_PAINCHART_GET : Serviceurls.SARAS_DOC_PAINCHART_GET 
                RestAPIService.create(data, path)
                    .then((response) => {
                        if (response.data.status === "success") {
                            ClearData();
                            getPainScaleData();
                            props.successMessage(response.data.message)
                            if (props?.fromIp) {
                                props?.callHistory(true)
                            }
                        } else {
                            props.errorMessage(response.data.message)
                        }
                    }).catch((error) => {
                        props.errorMessage(error.message)
                    })
            }
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const renderSmileBtn = (value, image, index) => {
        const isLast = index === painScaleImgList.length - 1;
        const isSelected = value === state.painValue;

        return (
            <Box
                key={index}
                flex="1"
                position="relative"
                height="100%"
                textAlign="center"
            >
                {/* Even number (above image) */}
                <Typography
                    position="absolute"
                    top="-3dvh"
                    left="45%"
                    transform="translateX(-50%)"
                    fontSize="0.9vw"
                    color="#616161"
                    zIndex={2}
                    backgroundColor="#fff"
                    px={0.5}
                >
                    {index * 2}
                </Typography>

                {/* Odd number (between images) */}
                {index < painScaleImgList.length - 1 && (
                    <Typography
                        position="absolute"
                        top="-3dvh"
                        left="95%"
                        transform="translateX(-50%)"
                        fontSize="0.9vw"
                        color="#616161"
                        zIndex={2}
                        backgroundColor="#fff"
                        px={0.5}
                    >
                        {index * 2 + 1}
                    </Typography>
                )}

                {/* Image container */}
                <Box
                    width="100%"
                    height="100%"
                    onClick={() => updateState({ painValue: value })}
                    sx={{
                        backgroundColor: isSelected ? "#04B7B1" : "transparent",
                        borderRight: isLast ? "none" : "1px solid #E3E2E2",
                        cursor: "pointer",
                        boxSizing: "border-box",
                    }}
                >
                    <Box
                        component="img"
                        src={image}
                        alt="smile"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                </Box>
            </Box>
        );
    };

    const { t } = props;

    const columns = [
        {
            field: 'pain_chart_date', headerName: t("DateTime"), flex: 0.333, headerAlign: "center", align: "center",
            renderCell: ({ row }) => {
                let startDate = row?.pain_chart_date ? new Date(row.pain_chart_date) : "";
                let date = DateTime.fromJSDate(startDate).toFormat("dd-MM-yyyy hh:mm a");
                return (<Box component={'div'}>{date ? (date) : '-'}</Box>)
            }
        },
        {
            field: "pain_level", flex: 0.433, headerName: t("PainLevel"), headerAlign: "center", align: "center",
            renderCell: ({ row }) => {
                const painItem = painLevelTxt[row?.pain_level];
                return (painItem ? <Box component={'div'} sx={{ display: "flex", flexDirection: "row", gap: "0.5vw" }}>
                    <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}>{row?.pain_level ? row?.pain_level : '-'}</Typography>
                    <img className='emedhub_pain_range' src={painItem.image} />
                    <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}>{painItem.status}</Typography>
                </Box> : "-")
            }
        },
        {
            field: "action", flex: 0.3, headerName: t("Action"), headerAlign: "center", align: "center",
            renderCell: ({ row }) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                <CommonEditButton testID={"pain_edit"} size={"1.5vw"} disable={props?.isLocked} onClick={() => onEditHandler(row)} />
                <CommonDeleteButton testID={"pain_delete"} size={"1.5vw"} disable={props?.isLocked || state.deleteID === row?.id} onClick={() => onDeleteHandler(row)} />
            </Box>
        }
    ]

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"}>
                    {renderTitle(Title, props.isSelected)}
                </Box>
                <Box>
                    <Box display="flex" justifyContent="center" alignItems="center" height="10vw" margin={"2dvw 0vw 0.625vw 0vw"}>
                        {painScaleImgList.map((item, index) => renderSmileBtn(item.value, item.image, index))}
                    </Box>
                    <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end" height={"6vh"}>
                        <ActionButton
                            text={"Clear"}
                            emed_tid='doc_notes_bold_clr'
                            variant={'outlined'}
                            onClick={() => ClearData()}
                        />
                        <ActionButton
                            text={"Save"}
                            emed_tid='doc_notes_bold_save'
                            disabled={!state?.painValue || props.isLocked}
                            onClick={() => { postPainScale() }}
                        />
                    </Stack>
                </Box>
                <Box height={'15vw'} overflowY={'auto'}>
                    <DataGrid
                        rows={state.painScaleList}
                        columns={columns}
                        getRowId={(row) => row['id']}
                        headerHeight={40}
                        hideFooter={true}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_DocNotes_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        disableSelectionOnClick
                    />
                </Box>
                {state.isDeleteClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")} ${Title}?`}
                    deleteAlertPopupClose={popupClose.bind(this)}
                    removeData={deletePainScale.bind(this)}
                />}
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(SarasPainScale)